import React from 'react';
import NestedTable from './NestedTable';
import { AppDispatch, RootState } from '../../../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPerformanceTableDataThunk,
  selectTableData,
  selectTableError,
  selectTableLoading,
  selectTableToggle,
  setPerformanceTableDataEmpty,
  setToggle,
} from '../../../../features/performanceTable/performanceTableSlice';
import { useAppSelector } from '../../../../state/hooks';
import { Grid, Skeleton } from '@mui/material';
import ErrorPopup from '../../../../components/ErrorPopup/ErrorPopup';
import { TableTag, TableTagGrey } from '../../../../assets/images/UI-dashboard';
import {
  PerformanceTableNote,
  PerformanceTableSection,
  PerformanceTableTitle,
  PerformanceToggleSection,
  PerformanceToggleTitle,
} from './SKUTable.Styled';

const SKUTable: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const tableData = useSelector((state: RootState) => selectTableData(state));
  const loading = useSelector((state: RootState) => selectTableLoading(state));
  const error = useSelector((state: RootState) => selectTableError(state));
  const toggle = useSelector((state: RootState) => selectTableToggle(state));
  const filtersState = useAppSelector((state) => state.filters);
  const { latest_year_month } = useAppSelector((state) => state.scenarioCreation);

  const handleToggleClick = async () => {
    dispatch(setPerformanceTableDataEmpty());
    await dispatch(setToggle(toggle === 'NIELSEN' ? 'INTERNAL' : 'NIELSEN'));
    const payload = {
      bottler: filtersState.enabledKeys.bottler,
      state: filtersState.enabledKeys.state,
    };
    await dispatch(fetchPerformanceTableDataThunk(payload));
  };

  const YTD =
    toggle === 'NIELSEN' ? latest_year_month?.latest_year_month_nielson : latest_year_month?.latest_year_month_revenue;

  return (
    <>
      <>
        <PerformanceTableSection>
          <Grid>
            <PerformanceTableTitle>Performance</PerformanceTableTitle>
          </Grid>
          <PerformanceToggleSection onClick={handleToggleClick}>
            {toggle === 'INTERNAL' ? (
              <img src={TableTag} alt="Table Tag" />
            ) : (
              <img src={TableTagGrey} alt="Table Tag" />
            )}
            <PerformanceToggleTitle
              sx={{
                color: toggle === 'INTERNAL' ? '#E81c0E' : '#D9D9D9',
                marginLeft: '5px',
                marginRight: '10px',
              }}
            >
              {'INTERNAL'}
            </PerformanceToggleTitle>
            {toggle === 'NIELSEN' ? <img src={TableTag} alt="Table Tag" /> : <img src={TableTagGrey} alt="Table Tag" />}
            <PerformanceToggleTitle
              sx={{
                color: toggle === 'NIELSEN' ? '#E81c0E' : '#D9D9D9',
                marginLeft: '5px',
              }}
            >
              {'NIELSEN'}
            </PerformanceToggleTitle>
          </PerformanceToggleSection>
        </PerformanceTableSection>
        {loading === true || tableData.length === 0 ? (
          <Grid
            style={{
              width: 623,
              height: 200,
            }}
          >
            <Skeleton variant="rectangular" height={200} />
          </Grid>
        ) : (
          tableData.length > 0 && <NestedTable data={tableData} toggle={toggle} />
        )}
        <PerformanceTableNote>
          Above values are calculated for <span style={{ fontWeight: 900 }}>YTD ({YTD})</span>
        </PerformanceTableNote>
      </>

      {error && (
        <ErrorPopup
          open={false}
          message={''}
          onClose={function (): void {
            throw new Error('Function not implemented.');
          }}
        />
      )}
    </>
  );
};

export default SKUTable;
